import { useState, type InputHTMLAttributes } from 'react';
import { IconButton, TextInput } from './ui.tsx';

/** Password field with a show/hide control. */
export function PasswordInput(props: InputHTMLAttributes<HTMLInputElement> & { invalid?: boolean }) {
  const [shown, setShown] = useState(false);
  return (
    <div className="relative">
      <TextInput {...props} type={shown ? 'text' : 'password'} dir="ltr" className="pe-11" />
      <IconButton
        icon={shown ? 'eyeOff' : 'eye'}
        label={shown ? 'Hide password' : 'Show password'}
        aria-pressed={shown}
        className="absolute end-1 top-1/2 -translate-y-1/2"
        onClick={() => setShown((s) => !s)}
      />
    </div>
  );
}
